import React, { FunctionComponent, PropsWithChildren } from 'react'
import { useCheckoutSummaryRouteGuard } from './hooks'

export const SummaryRouteGuard: FunctionComponent<PropsWithChildren> = ({ children }) => {
  // Handle all routing logic (redirects, prefetching, etc.)
  useCheckoutSummaryRouteGuard()

  // Children render regardless of routing (routing happens via side effects)
  return <>{children}</>
}
